export const PROJECT_TABS = {
  overview: 'Overview',
  plan: 'Plan',
  content: 'Content',
  styleGuide: 'Style Guide',
  channels: 'Channels',
};
